
/* custom block - prepare object to firebase analytics */
/*
Key: max 40 characters long
Value: max 100 characters long
max 20 parameters per event
max 500 events per project
firebase analytics : Item cannot contain an array-based parameter (error 21) // https://firebase.google.com/docs/analytics/errors
*/
import lib from '@/library'
import store from '@/store'
import config from '@/config'
import Axios from 'axios'

var prefix = window.ctsautoconf.FIREBASE_ANALYTICS_PREFIX || 'igt'
prefix = prefix + '_'

function dataParser (obj, xtremeObj = false) {
  if (obj) {
    let eventName = obj.event
    let object = {}
    if (eventName) delete obj.event
    for (const property in obj) {
      if (typeof obj[property] === 'object') continue
      object[property] = obj[property]
    }
    console.log('analytics bridge - obj and event name', {eventName, object})
    if (config.app.autoconf.FIREBASE_ANALYTICS) logEvent(prefix + eventName, object)
    if (config.app.autoconf.APPSFLYER_ANALYTICS) appsFlyer(eventName, object)
    if (config.app.autoconf.PLAYER_PERSONALISATION.vaixEventTracker) eventTracker(eventName, obj)
  }
  if (((config.app.autoconf.XTREMEPUSH_ANALYTICS && config.app.autoconf.XTREMEPUSH_ANALYTICS.MOBILE_APP) || window.xtremepush) && xtremeObj) xtremePush(xtremeObj)
}

/* end of custom block */

/* firebase block */
function logEvent (name, params) {
  console.log('firebase analytics event', {name, params})
  if (!name) {
    return
  }

  if (window.AnalyticsWebInterface) {
    // Call Android interface
    window.AnalyticsWebInterface.logEvent(name, JSON.stringify(params))
  } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.firebase) {
    // Call iOS interface
    var message = {
      command: 'logEvent',
      name: name,
      parameters: params
    }
    window.webkit.messageHandlers.firebase.postMessage(message)
  } else {
    // No Android or iOS interface found
    console.warn('firebase analytics - No native APIs found.')
  }
}

function setUserProperty (name, value) {
  if (!name || !value) {
    return
  }

  if (window.AnalyticsWebInterface) {
    // Call Android interface
    window.AnalyticsWebInterface.setUserProperty(name, value)
  } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.firebase) {
    // Call iOS interface
    var message = {
      command: 'setUserProperty',
      name: name,
      value: value
    }
    window.webkit.messageHandlers.firebase.postMessage(message)
  } else {
    // No Android or iOS interface found
    console.warn('firebase analytics - No native APIs found.')
  }
}
/* end of firebase block */

/* appsFlyer block */
function appsFlyer (name, params) {
  console.log('appsFlyer', name)
  console.log('appsFlyer', params)
  /*
  key - generic event name
  value - appsFlyer predefined event name
  */
  var eventMapper = {
    'login': 'af_login',
    'signup_complete': 'af_complete_registration',
    'bet': 'af_purchase',
    'first_bet': 'first_purchase',
    'first_deposit confirm': 'first_deposit',
    'deposit confirm': 'deposit',
    'first_withdrawal confirm': 'first_withdrawal',
    'withdrawal confirm': 'withdrawal',
    'first_deposit_confirm': 'first_deposit',
    'deposit_confirm': 'deposit',
    'first_withdrawal_confirm': 'first_withdrawal',
    'withdrawal_confirm': 'withdrawal'
  }
  if (eventMapper[name]) {
    var args
    if (name === 'login') args = eventMapper[name]
    if (name === 'signup_complete') args = eventMapper[name] + '+' + JSON.stringify({'af_registration_method': params['accountId']})
    if ((name === 'bet' || name === 'first_bet') && params['gaEventAction'] === 'bet success') {
      let values = {
        'af_revenue': params['betAmount'],
        'af_currency': 'USD',
        'af_quantity': params['betCount'],
        'af_content_id': params['betSlipID'],
        'af_order_id': params['transactionId']
      }
      args = eventMapper[name] + '+' + JSON.stringify(values)
    }
    if ((name === 'deposit confirm' || name === 'first_deposit confirm')) {
      let values = {
        'af_revenue': params['stake'],
        'af_currency': 'USD'
      }
      args = eventMapper[name] + '+' + JSON.stringify(values)
    }
    if ((name === 'withdrawal confirm' || name === 'first_withdrawal confirm')) {
      let values = {
        'af_revenue': params['stake'],
        'af_currency': 'USD'
      }
      args = eventMapper[name] + '+' + JSON.stringify(values)
    }
    console.log('appsFlyer args: ', args)
    try {
      console.log('userAgent', userAgent.os)
      if (userAgent.os === 'ios' && args) {
        console.log('send to apps flyer bridge - ', args)
        window.webkit.messageHandlers.appsFlyer.postMessage(args)
      }
      if (userAgent.os === 'android' && args) {
        console.log('send to apps flyer bridge - ', args)
        /* eslint-disable */
        android.appsFlyer(args)
        /* eslint-enable */
      }
    } catch (error) {
      console.warn('appsFlyer Bridge Error - ', {'error': error})
    }
  }
}
/* end of appsFlyer block */

/* Xtremepush Web and mobile */

function xtremePush (event) {
  if (window.xtremepush) {
    console.log('xtremepush desktop/site event:', event)
    if (Object.keys(event).length === 3) {
      if (config.app.autoconf.XTREMEPUSH_ANALYTICS && config.app.autoconf.XTREMEPUSH_ANALYTICS.EXCLUDED_EVENTS && config.app.autoconf.XTREMEPUSH_ANALYTICS.EXCLUDED_EVENTS.includes(event.param2)) return false
      window.xtremepush(event.param1, event.param2, event.param3)
      return false
    }
    if (Object.keys(event).length === 2 && event.param2 === 'registration_completed_cs') {
      window.xtremepush(event.param1, event.param2)
      return
    }
    window.xtremepush(event.param1, event.param2)
    return false
  }
  if (config.app.autoconf.XTREMEPUSH_ANALYTICS && config.app.autoconf.XTREMEPUSH_ANALYTICS.MOBILE_APP) {
    console.log('xtremepush mobile app event:', event)
    let args
    if (Object.keys(event).length === 2) {
      if (event.param2 === 'registration_completed_cs') {
        args = event.param2 + '+' + JSON.stringify({'customer_online_id': localStorage.customer})
        args = {
          'event_name': event.param2,
          'content': {'customer_online_id': localStorage.customer}
        }
      } else {
        args = {
          'event_name': event.param2
        }
      }
      args = JSON.stringify(args)
    }
    if (Object.keys(event).length === 3) {
      // args = event.param2 + '+' + JSON.stringify(event.param3)
      if (config.app.autoconf.XTREMEPUSH_ANALYTICS && config.app.autoconf.XTREMEPUSH_ANALYTICS.EXCLUDED_EVENTS && config.app.autoconf.XTREMEPUSH_ANALYTICS.EXCLUDED_EVENTS.includes(event.param2)) return false
      args = {
        'event_name': event.param2,
        'content': event.param3
      }
      args = JSON.stringify(args)
    }
    try {
      if (userAgent.os === 'ios' && args) {
        console.log('send to xtremepush bridge - ', args)
        window.webkit.messageHandlers.xtremePush.postMessage(args)
      }
      if (userAgent.os === 'android' && args) {
        console.log('send to xtremepush bridge - ', args)
        /* eslint-disable */
        android.xtremePush(args)
        /* eslint-enable */
      }
    } catch (error) {
      console.warn('xtremepush Bridge Error - ', {'error': error})
    }
  }
}
/* end of Xtremepush block */

/* VAIX Event Tracker */

function eventTracker (name, params) {
  // console.log('eventTracker: ', name)
  // console.log('eventTracker: ', params)

  const isLogin = name === 'login' && params.gaEventAction === 'login success' && params.loginStatus === 'logged in'
  const isRecommended = store.getters['recommendedState/getRecommendedEventsTabActive']
  const isRecommendedEvents = params.recommended && params.module === 'events'
  const isRecommendedMarkets = params.recommended && params.module === 'markets'
  const isParlayZone = params && params.pagePath && params.pagePath.includes('parlayzone')
  const menuItem = isRecommendedEvents || isRecommendedMarkets || isParlayZone

  const isAvailableForTracking = params.origin || params.parlayOrigin || menuItem || isLogin

  if (isAvailableForTracking) {
    const isCombination = name === 'popular_parlays' && params.gaEventAction === 'add to betslip'
    const isOutcome = params.selectionId && ['add to betslip', 'add to fast betslip'].includes(params.gaEventAction)
    const isEvent = params.gaEventLabel === 'more wagers'
    const isSport = name === 'ga_pageload' && params.sport !== 'N/A'

    const isRequiredEvent = isLogin || isOutcome || isCombination || isSport || isEvent || menuItem

    if (isRequiredEvent) {
      const userId = (localStorage.customer && localStorage.customer !== 'undefined') ? localStorage.customer : null
      let dataObject = {}

      if (isEvent) {
        dataObject = {
          'user_id': userId,
          'event_type': 'clicks:event',
          'data': {
            'event_id': params.eventId || null,
            'event_name': params.eventName || null,
            'sport': params.sport || null,
            'competition': params.competition || null,
            'location': `widget:${(params.origin || params.parlayOrigin) && isRecommended && !params.popularParlaysType ? 'recommended' : params.routeName === 'parlayzone' ? `popularparlays:${params.routeName}` : 'popularparlays'}`,
            'page': params.location || null,
            'origin': params.origin || params.parlayOrigin || null
          }
        }
      }
      if (isOutcome) {
        dataObject = {
          'user_id': userId,
          'event_type': 'clicks:outcome',
          'data': {
            'event_id': params.eventId || null,
            'event_name': params.eventName || null,
            'sport': params.sport || null,
            'competition': params.competition || null,
            'outcome_id': params.selectionId || null,
            'selectionName': params.selectionName || null,
            'location': `widget:${params.module ? 'recommended' : 'recommended:markets'}`,
            'page': params.location || null,
            'origin': params.origin || null
          }
        }
      }
      if (isSport) {
        dataObject = {
          'user_id': userId,
          'event_type': 'clicks:sport',
          'data': {
            'sport': params.sport || null,
            'location': `widget:${params.module || null}`,
            'origin': params.origin || null
          }
        }
      }
      if (isCombination) {
        const selectionData = params.selectionsAdded
        const addedParlay = []
        selectionData.forEach(item => {
          const idfoevent = item.market.idfoevent
          const idfoselection = item.selections[0].idfoselection
          addedParlay.push({
            id: idfoselection,
            event_id: idfoevent
          })
        })
        dataObject = {
          'user_id': userId,
          'event_type': 'clicks:combination',
          'data': {
            'selections': addedParlay || null,
            'type_of_parlay': params.type || null,
            'location': `widget:${params.module + ':' + (params.routeName === 'sports' ? 'home' : params.routeName)}`,
            'origin': params.origin || null
          }
        }
      }
      if (menuItem) {
        dataObject = {
          'user_id': userId,
          'event_type': 'clicks:menu-item',
          'data': {
            'item': 'recommended',
            'location': `widget:${params.module ? 'recommended:' + params.module : 'parlayzone'}`
          }
        }
      }
      if (isLogin) {
        dataObject = {
          'user_id': userId,
          'event_type': 'users:login'
        }
      }

      const data = JSON.stringify(dataObject)

      const conf = {
        method: 'post',
        maxBodyLength: Infinity,
        url: config.app.autoconf.VAIX_EVENT_TRACKER.VAIX_API_URL,
        headers: {
          'x-vaix-client-id': config.app.autoconf.VAIX_EVENT_TRACKER.HEADERS.ID,
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + config.app.autoconf.VAIX_EVENT_TRACKER.HEADERS.AUTH
        },
        data: data
      }
      if (config.app.autoconf.VAIX_EVENT_TRACKER.VAIX_API_URL) {
        Axios.request(conf)
          .then(() => {
            console.log('Event Tracker - data sent successfully')
          })
          .catch((error) => {
            console.error('Event Tracker - Error: ', error)
          })
      }
    }
  }
}

/* end of VAIX event tracker block */

const userAgent = {
  get os () {
    return lib.core.userAgent.os.name
  }
}

export default {
  setUserProperty,
  dataParser,
  xtremePush
}



// WEBPACK FOOTER //
// ./src/library/analyticsBridge/index.js